import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import { getFleetMaintenanceRules } from '../../../services/fleetService';
import { apiParamsState } from '../../../storage/app';
import {
  fleetMaintenaceRulesHasAnyFilterState,
  fleetMaintenanceRulesFiltersState,
  fleetMaintenanceRulesReloadListState,
} from '../../../storage/fleetMaintenaceRules';

function useFleetMaintenanceRules() {
  const apiParams = useRecoilValue(apiParamsState);
  const [filters, setFilters] = useRecoilState(fleetMaintenanceRulesFiltersState);
  const [reload, setReload] = useRecoilState(fleetMaintenanceRulesReloadListState);
  const resetAllFilters = useResetRecoilState(fleetMaintenanceRulesFiltersState);
  const hasActiveFilters = useRecoilValue(fleetMaintenaceRulesHasAnyFilterState);

  const resetFilters = () => {
    setFilters((prev) => ({
      ...prev,
      triggerType: undefined,
      maintenanceTypeId: undefined,
      ownedByMe: false,
    }));
  };

  const onReload = () => {
    setReload((prev) => !prev);
  };

  const onChangeFilter = (filterName: keyof typeof filters, value: any) => {
    setFilters((prev) => ({
      ...prev,
      [filterName]: value,
    }));
  };

  const loadFleetMaintenanceRules = async () => {
    if (!apiParams)
      return {
        configurations: undefined,
        error: 'Selecciona un espacio de trabajo.',
        total: undefined,
      };
    const { configurations, error, total } = await getFleetMaintenanceRules({
      page: filters.page,
      clientId: apiParams.clientId,
      subClientId: apiParams.subClientId,
      triggerType: filters.triggerType,
      maintenanceTypeId: filters.maintenanceTypeId,
      search: filters.search,
    });
    return {
      configurations,
      error,
      total,
    };
  };

  return {
    hasActiveFilters,
    loadFleetMaintenanceRules,
    onReload,
    reload,
    resetAllFilters,
    resetFilters,
    page: filters.page,
    onChangePage: (page: number) => {
      onChangeFilter('page', page);
    },
    search: filters.search,
    onChangeSearch: (search: string) => {
      onChangeFilter('search', search);
    },
    filters: {
      triggerType: filters.triggerType,
      maintenanceTypeId: filters.maintenanceTypeId,
    },
    onChangeFilter: (filterName: 'triggerType' | 'maintenanceTypeId', value: any) => {
      onChangeFilter(filterName, value);
    },
  };
}

export default useFleetMaintenanceRules;
